/**
 * ----------
 * Input
 * ----------
 * gère le style des inputs
 */
export default class Input {

    constructor() {
        Input.initInput();
        Input.onFocus();
        Input.onFocusOut();
        Input.onInput();
    }

    /**
     * ------------
     * initInput
     * ------------
     * Gère l'animation du label au focus sur un input
     */
    static initInput = function () {
        $('input, textarea').each(function (index, item) {
            if ($(item).val() !== '') {
                $(item).addClass('focus');
                $(item).parent().find('[data-input-label-focus]').addClass('focus');
            }
        })
    }

    /**
     * ------------
     * onFocus
     * ------------
     * Gère l'animation du label au focus sur un input
     */
    static onFocus = function () {
        $(document).on('focus', 'input, textarea', function (event) {
            const input = $(event.currentTarget);
            $(input).addClass('focus');
            $(input).parent().find('[data-input-label-focus]').addClass('focus');

            if (window.matchMedia("(max-width: 1000px)").matches && $(input).attr('data-network-search') || $(input).attr('data-itinerary-input')) {
                const scrollTop = $(input).scrollTop();
                $("html, body").animate({scrollTop: scrollTop});
            }
        });
    }

    /**
     * ------------
     * onFocusOut
     * ------------
     * Gère l'animation du label lors de la sortie de l'input
     */
    static onFocusOut = function () {
        $(document).on('focusout', 'input, textarea', function (event) {
            const input = $(event.currentTarget);
            if ($(input).val() === '') {
                $(input).removeClass('focus');
                $(input).parent().find('[data-input-label-focus]').removeClass('focus');
            }
        });
    }

    /**
     * ------------
     * onInput
     * ------------
     * Gère le style des inputs ayant un autocomplete
     */
    static onInput = function () {
        // network autocomplete
        $(document).on('input-fill', function (event, element) {
            $(element).addClass('fill');
            $(element).parent().next('[data-autocomplete]').addClass('active');
        });

        $(document).on('input-empty', function (event, element) {
            $(element).removeClass('fill');
            $(element).parent().next('[data-autocomplete]').removeClass('active');
        });
    }
}
